






























































import {
  Vue,
  Component,
  Prop, Watch,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import VueRouter from "vue-router";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerUserStore } from "@/shared/store/partnerUser";
import { FetchState, RoleType } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useRoleStore } from "@/shared/store/role";

@Component({
  components: {
    Input,
    Button,
    EmployerPhone,
    ErrorSummary
  }
})
export default class PartnerUserAdd extends Vue {
  $router: VueRouter;
  $validator: Validator;

  notifierStore = useNotifierStore();
  partnerUserStore = usePartnerUserStore();
  rolePermissionsStore = useRolePermissionsStore();
  roleStore = useRoleStore();

  @Prop() partnerId: number;

  // form fields
  firstName = "";
  lastName = "";
  phone = "";
  jobTitle = "";
  email = "";
  selectedUserRoles = [];

  partnerRoles = [];

  mounted (): void {
    this.roleStore.getPartnerRoles();
  }

  get selectOptions () {
    return this.roleStore.partnerRoles.map(role => ({text: role.displayName ? role.displayName : role.roleName, value: role.roleId}));
  }

  // other
  isSubmitting = false;

  get submitDisabled (): boolean {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  clearForm (): void {
    this.firstName = "";
    this.lastName = "";
    this.jobTitle = "";
    this.email = "";
    this.phone = "";
    this.selectedUserRoles = [];

    this.$validator.reset();
  }

  submit (): void {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }

        this.isSubmitting = true;
        this.partnerUserStore.partnerUserSave({
          partnerId: this.partnerId,
          partnerUser: {
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            jobTitle: this.jobTitle,
            email: this.email,
            userRoles: this.selectedUserRoles
          } as any
        }).then((userSave: any) => {
          if (userSave.error) {
            this.notifierStore.setDanger(userSave.error);
            this.isSubmitting = false;
          } else {
            this.notifierStore.setSuccess("Partner user saved");
            this.clearForm();
            this.isSubmitting = false;
          }
        })
          .catch(err => {
            this.isSubmitting = false;
            this.notifierStore.setDanger("Could not save user");
          });
      });
  }
}
